export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0064_thumb.75e63db5.jpg";